import * as React from "react";
import {
  TrackerPolicy,
  TrackerPolicyContentStatusOptions,
  TrackerPolicyContentTypeOptions
} from "@models/tracker-policy";
import {Table, Icon} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import __i18n from "../../../../../intl/__i18n";
import {Link} from "react-router-dom";
import FormattedDateTime from '../../../../custom/FormattedDateTime';

type Props = {
  data: TrackerPolicy[];
  loading: boolean;
  deleteFn: (item: TrackerPolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const DiscountCodeStatisticsList: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: __i18n("Used Date"),
      dataIndex: 'date_time',
      key: 'date_time',
      align:"right",
      render: (date_time) => <FormattedDateTime showTime={false} date={date_time}/>
    },
    {
      title: __i18n("Total"),
      dataIndex: "total",
      key: "total",
      align: "left",
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default DiscountCodeStatisticsList;
